export default __webpack_public_path__ + "static/media/2dechologo.6451c17b.svg";